<template>
  <div>
    <header class="bar bar-nav">
      <a class="icon icon-left pull-left" @click="tolast" v-if="!isWapp"></a>
      <h1 class="title">秒杀专场</h1>
    </header>
    <div class="bar bar-header-secondary countdown-bar">
      <span class="link" style="color:red;float:left;" v-if="secFlag === 0">抢购即将开始，敬请期待</span>
      <span class="link" style="color:red;float:left;" v-else-if="secFlag === 1">
        <span v-if="secInfo.limitNumber > 0">已售{{secInfo.usedNumber}}单</span>
        <!--<span v-if="secInfo.limitNumber > 0">已售{{Math.floor(secInfo.usedNumber/2)}}单</span>-->
        <span v-else>抢购中</span>
      </span>
      <span style="color: #FFFFFF;background: #666;border-radius:3px;padding: 2px 3px;" v-else>秒杀结束</span>
      <span class="link countdown" style="float:right">
        <Countdown :startDT="secInfo.startDT" :endDT="secInfo.endDT"></Countdown>
      </span>
    </div>
    <div class="content">
      <div class="card facebook-card">
        <div class="card-content">
          <a href="https://jinshuju.net/f/nrxuBV" target="_blank" v-if="openLink()">
            <img :src="baseurl + $route.query.detailImageUrl" width="100%">
          </a>
          <img :src="baseurl + $route.query.detailImageUrl" width="100%" v-else>
        </div>
      </div>
      <newMerchandiseListA :merch-list="merchandise" :description="$route.query.des" :channel="$route.params.channel" ></newMerchandiseListA>
      <div v-if="merchandise.length>10" class="button"  @click="loadmore">更多...</div>
      <div id="over" style="text-align: center;"></div>
    </div>
  </div>

</template>

<script>
  import $ from 'jquery'
  import emkt from '../../emkt.js'
  import {mapMutations, mapState, mapGetters} from 'vuex'
  import newMerchandiseListA from '../finder/components/NewMerchandiseListA'
  import Countdown from '../../components/Countdown'

  export default {
    name: 'SecPromotion',
    components: {newMerchandiseListA, Countdown},
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/promotion/',
        merchandise: [],
        total: 0,
        startDT: '',
        endDT: '',
        secPromotion: emkt.getLocalStorage('EmktSecPromotion'),
        isWapp: emkt.isWapp
      }
    },
    computed: {
      ...mapState([
        'secInfo'
      ]),
      ...mapGetters([
        'secFlag'
      ])
    },
    mounted () {
      this.fetchData()
      this.getSecPromotionInfo()
    },
    methods: {
      ...mapMutations([
        'SET_SECPROMOTION_INFO'
      ]),
      fetchData () {
        // get merchandise list
        if (this.$route.query.id === '') {
          if (emkt.getLocalStorage('EmktRecommendations') && emkt.getLocalStorage('EmktRecommendations').length > 0) {
            this.merchandise = emkt.getLocalStorage('EmktRecommendations')
          } else {
            this.merchandise = emkt.getLocalStorage('EmktAllRecommends')
          }
        } else {
          this.gcapi('queryMerchandise', {promotionGuid: this.$route.query.id, fromIndex: 0}).then((response) => {
            this.merchandise = response.body.result.merchandiseList
            this.total = response.body.result.total
            console.log('merchandise', this.merchandise, this.total)
          })
        }
      },
      loadmore () {
        var fromindex = this.merchandise.length
        if (fromindex >= this.total) {
          $('.button').remove()
          $('#over').append('已经到底啦！')
          return
        } else {
          var addlist = []
          this.gcapi('queryMerchandise', {promotionGuid: this.$route.query.id, fromIndex: fromindex}).then((response) => {
            addlist = response.body.result.merchandiseList
            for (var i = 0; i < addlist.length; i++) {
              this.merchandise.push(addlist[i])
            }
          })
        }
      },
      tolast () {
        return this.$router.go(-1)
      },
      getSecPromotionInfo () {
        let info = {}
        if (this.secPromotion === '' || this.secPromotion === undefined) {
          return
        }
        info.startDT = this.secPromotion.startDT
        info.endDT = this.secPromotion.endDT
        info.promotionGuid = this.secPromotion.promotionGuid
        info.now = Date.parse(new Date())
        this.gcapi('getSeckillPromotion', info.promotionGuid)
          .then((response) => {
            const result = response.body.result
            Object.assign(info, result)
            this.SET_SECPROMOTION_INFO(info)
            console.log('secinfo', this.secInfo)
            console.log('secflag', this.secFlag)
          })
      },
      openLink () {
        const promotionId = this.$route.query.id
        const type = this.$route.query.type
        if (promotionId.endsWith('161') && type === 6) {
          return true
        }
        return false
      }
    }
  }
</script>

<style scoped>
  .content {
    margin-top: -0.7rem
  }
  .card-content {
    border-bottom: 1px solid rgba(129, 129, 119, 0.38)
  }
  .card {
    margin: 0
  }
  .countdown-bar {
    line-height: 1.5rem;
    height: 1.5rem;
    font-size: 0.6rem;
    color: #3d4145;
    margin:0;
    padding: 0 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// SecPromotion.vue?6d3e2c60